import React from "react";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import NoGoogle from "../../../assets/images/nogoogle.svg";
import NoPost from "../../../assets/images/rafiki.png";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  locationbox: {
    display: "row",
    alignItems: "center",
    textAlign: "center",
    marginTop: "50px",
  },
  locationsubhead: {
    marginTop: "8px",
    marginBottom: "8px",
    textAlign: "center",
    fontWeight: 400,
    fontSize: "16px",
    color: "#495059",
  },
  locationhead: {
    marginTop: "8px",
    marginBottom: "8px",
    textAlign: "center",
    fontWeight: 700,
    fontSize: "32px",
    color: "#1B2430",
  },
  Imagesection: {
    marginTop: "8px",
    height: "250px",
  },
  Imagesection2: {
    marginTop: "8px",
    height: "250px",
  },
}));

const NotConnected = ({ text, subtext }) => {
  const classes = useStyles();
  return (
    <Box className={classes.locationbox}>
      <img alt="" className={classes.Imagesection} src={NoPost} />
      <Typography className={classes.locationhead}>{text}</Typography>
    </Box>
  );
};

export default NotConnected;
